import { ReactComponent } from '../../../../Utils/Types';
import { Box } from '../../Components/Box/Box';
import { PageLayout } from '../../Components/PageLayout/PageLayout';
import { TwitchAuthButton } from '../../Components/TwitchAuthButton/TwitchAuthButton';

export function HomePage(): ReactComponent {
  return (
    <div className="v-stack items-center justify-center" style={{ minHeight: '100vh' }}>
      <PageLayout>
        <Box>
          <div className="p-5 v-stack items-center space-y-8">
            <div className="v-stack items-center space-y-2">
              <img className="w-32 h-32" src="/images/icons/moon_shiny_red.svg" />
              <div className="v-stack items-center">
                <h1 className="text-text text-2xl text-center font-bold">Welcome to project Odyssey!</h1>
                <h3 className="text-text text-center">Authenticate with your twitch account to get started.</h3>
              </div>
            </div>
            <TwitchAuthButton />
          </div>
        </Box>
      </PageLayout>
    </div>
  );
}
